import React, {useEffect, Component, useState } from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import {ReactComponent as SvgDotPatternIcon} from "../../images/dot-pattern.svg"

import { useForm, Controller } from "react-hook-form";

import { useSnackbar } from "react-simple-snackbar";
import Select from 'react-select'

import 'components/forms/SimpleContactUsLogin.css'

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const FormContainer = styled.div`
  ${tw`p-10 sm:p-12 md:p-16 bg-primary-500 text-gray-100 rounded-lg relative`}
  form {
    ${tw`mt-4`}
  }
  h2 {
    ${tw`text-3xl sm:text-4xl font-bold`}
  }
  input,textarea {
    ${tw`w-full bg-transparent text-gray-100 text-base font-medium tracking-wide border-b-2 py-2 text-gray-100 hocus:border-pink-400 focus:outline-none transition duration-200`};

    ::placeholder {
      ${tw`text-gray-500`}
    }
  }
`;

const TwoColumn = tw.div`flex flex-col sm:flex-row justify-between`;
const Column = tw.div`sm:w-5/12 flex flex-col`;
const InputContainer = tw.div`relative py-5 mt-6`;
const Label = tw.label`absolute top-0 left-0 tracking-wide font-semibold text-sm`;
const Input = tw.input``;
const TextArea = tw.textarea`h-24 sm:h-full resize-none`;
const SubmitButton = tw.button`w-full sm:w-32 mt-6 py-3 bg-gray-100 text-primary-500 rounded-full font-bold tracking-wide shadow-lg uppercase text-sm transition duration-300 transform focus:outline-none focus:shadow-outline hover:bg-gray-300 hover:text-primary-700 hocus:-translate-y-px hocus:shadow-xl`;

const SvgDotPattern1 = tw(SvgDotPatternIcon)`absolute bottom-0 right-0 transform translate-y-1/2 translate-x-1/2 -z-10 opacity-50 text-primary-500 fill-current w-24`

export default ({toggleModalLogin, loggato, setLoggato, update}) => {

  const { register, handleSubmit, watch, errors, setValue } = useForm();
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const [fasciaSelezionata, setFasciaSelezionata] = useState(0);

  useEffect(() => {

    if(localStorage.getItem("nome_1000") !== null && localStorage.getItem("citta_1000") !== null){

      setValue("nome", localStorage.getItem("nome_1000"));
      setValue("citta", localStorage.getItem("citta_1000"))
      
    }
  
  }, [])

  var today = new Date();
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  var yyyy = today.getFullYear();

  today = dd + '/' + mm + '/' + yyyy;

  const options = [
    { value: '1', label: '00:00 - 01:00' },
    { value: '2', label: '01:00 - 02:00' },
    { value: '3', label: '02:00 - 03:00' },
    { value: '4', label: '03:00 - 04:00' },
    { value: '5', label: '04:00 - 05:00' },
    { value: '6', label: '05:00 - 06:00' },
    { value: '7', label: '06:00 - 07:00' },
    { value: '8', label: '07:00 - 08:00' },
    { value: '9', label: '08:00 - 09:00' },
    { value: '10', label: '09:00 - 10:00' },
    { value: '11', label: '10:00 - 11:00' },
    { value: '12', label: '11:00 - 12:00' },
    { value: '13', label: '12:00 - 13:00' },
    { value: '14', label: '13:00 - 14:00' },
    { value: '15', label: '14:00 - 15:00' },
    { value: '16', label: '15:00 - 16:00' },
    { value: '17', label: '16:00 - 17:00' },
    { value: '18', label: '17:00 - 18:00' },
    { value: '19', label: '18:00 - 19:00' },
    { value: '20', label: '19:00 - 20:00' },
    { value: '21', label: '20:00 - 21:00' },
    { value: '22', label: '21:00 - 22:00' },
    { value: '23', label: '22:00 - 23:00' },
    { value: '24', label: '23:00 - 00:00' },
  ]

  const colourStyles = {
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        color: '#6415ff',
      };
    },
  };

  const methods = useForm();

  
  const onSubmit = data => {
    data.fascia = fasciaSelezionata;
    let giorno = new Date(data.data);
    let tdd = String(giorno.getDate()).padStart(2, '0');
    let tmm = String(giorno.getMonth() + 1).padStart(2, '0'); //January is 0!
    let tyyyy = giorno.getFullYear();

    data.data= tdd + '/' + tmm + '/' + tyyyy;
    console.log(data);

    if(data.nome!=='' && data.citta!=='' && data.fascia!==0){

      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: JSON.stringify(data)
      };

      fetch('https://recode.digital/corona-anti-virus/index.php/api/crea_ora_guardia/', requestOptions)
        .then(response => response.text())
        .then(risp => {
          if(risp.trim() === "ok"){

            localStorage.setItem('nome_guardia', data.nome);
            localStorage.setItem('citta_guardia', data.citta);
            localStorage.setItem('data_guardia', today);
            openSnackbar('Grazie! Aggiorna la pagina per vedere il tuo nome nella lista.');

          }

        });

        toggleModalLogin();

        const formData = new FormData();

        formData.append('data', today); 

        const requestOptions2 = {
          method: 'POST',
          body: formData
          //Essendo creato con FormData non devo specificare headers
        };

        fetch('https://recode.digital/corona-anti-virus/index.php/api/conta_ore_guardia/', requestOptions2)
                .then(response => response.text())
                .then(risp => {

                  update(parseInt(risp))
                });  

    }else{
      openSnackbar('Compilare tutti i campi richiesti');
    }
  }

  return (
    <Container id="form_iscrizione">
      <Content>
        <FormContainer>
          <div tw="mx-auto max-w-4xl" >
            <div style={{textAlign:"right"}} onClick={toggleModalLogin}>
              <p><b>X Chiudi</b></p>
            </div>
            <h2>Registra la tua ora di guardia 🛡️✝️</h2>
            <form onSubmit={handleSubmit(onSubmit)}>
              <input type="hidden" ref={register} value={today} name="data"/>
              <TwoColumn>
                <Column>
                  <InputContainer>
                    <Label htmlFor="email-input">Il tuo nome di Battesimo*</Label>
                    <Input ref={register} id="nome" type="text" name="nome" placeholder="" />
                  </InputContainer>
                </Column>
                <Column>
                <InputContainer>
                    <Label htmlFor="password">Città*</Label>
                    <Input ref={register} id="citta" type="text" name="citta" placeholder="" />
                  </InputContainer>
                </Column>
              </TwoColumn>
              <Column>
                <InputContainer>
                  <Label htmlFor="password">Scegli la tua fascia oraria*</Label>
                  <Select ref={register} id="fascia" name="fascia" options={options} styles={colourStyles} onChange={(option) => {setFasciaSelezionata(option.value);}} />
                </InputContainer>
              </Column>
              <Column>
                <InputContainer>
                  <Label htmlFor="password">Per quale giorno?*</Label>
                  {/* <Select ref={register} id="fascia" name="fascia" options={options} styles={colourStyles} onChange={(option) => {setFasciaSelezionata(option.value);}} /> */}
                  <input ref={register} type="date" id="data" name="data"
                    defaultValue={yyyy+"-"+mm+"-"+dd}
                    min={yyyy+"-"+mm+"-"+dd} >
                  </input>
                </InputContainer>
              </Column>

              <SubmitButton style={{width:"100%"}}type="submit" value="Submit">Conferma e registra la tua ora di guardia 🛡️✝️</SubmitButton>
            </form>
          </div>
          <SvgDotPattern1 />
        </FormContainer>
      </Content>
    </Container>
  );
};
